export const TODO = (msg: string = "Implement me") => {
    throw new Error(msg);
};
